import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { resolveCountryLanguage } from '../../../helpers/aiTrackingCountryLanguage';
import ProjectEditModal from '../projects/modal/EditProject/modal';
import { guessMarket, marketFromDomain } from './market';
import { STEP_BRAND, TOTAL_STEPS } from './state';

/**
 * Step 1: the brand and the domain, on the project's own edit form.
 *
 * This is the same form the project settings page and the prompt generator open, in its
 * onboarding mode -- one form means one set of rules about what a valid domain is and one place
 * where the server's domain errors are already understood. What onboarding changes is only what
 * is asked for: the project name it was created with is left alone, clients are a concern for
 * later, and the market is carried as a line the user can open rather than two more selects to
 * fill in, because every step after this one refuses to run without it.
 *
 * Saving does not return to wherever this was opened from; it hands the saved project up so the
 * flow can go straight on to profiling it.
 */
class StepBrand extends Component {
    render() {
        const { t, project, isOpen, onSaved, onClose } = this.props;

        // The project's own market first, then the user's last pick, and only then a guess --
        // so a project that already knows where it sells is never second-guessed by a TLD.
        const market = resolveCountryLanguage(project, guessMarket(project?.own_domain));

        return (
            <ProjectEditModal
                isOpen={isOpen}
                onboarding
                hideClients
                item={project}
                defaultMarket={market}
                deriveMarket={marketFromDomain}
                title={t('ai_tracking.onboarding.step_header', {
                    current: STEP_BRAND,
                    total: TOTAL_STEPS,
                    name: t('ai_tracking.onboarding.steps.brand'),
                })}
                subtitle={t('ai_tracking.onboarding.brand.subtitle')}
                submitLabel={t('ai_tracking.onboarding.continue')}
                closeLabel={t('ai_tracking.onboarding.finish_later')}
                onSaved={onSaved}
                onClose={onClose}
            />
        );
    }
}

export default withTranslation()(StepBrand);
